import { Button, Card, Col, Form, Input, Row, Typography } from "antd";
import React, { useState, useEffect } from "react";
import styles from "./Login.module.css";
import { useDispatch } from "react-redux";
import { changePassword } from "../../redux/actions/user/changePasswordAction";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const ChangePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    // Check if user has isRequired flag
    const isRequired = localStorage.getItem("isRequired");
    const token = localStorage.getItem("access-token");
    
    if (!token || isRequired !== "true") {
      toast.error("Please login with a reset code first");
      navigate("/auth/login");
    }
  }, [navigate]);

  const onFinish = async (values) => {
    if (values.newPassword !== values.confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    setLoader(true);
    const resp = await dispatch(changePassword(values.newPassword));
    if (resp === "success") {
      setLoader(false);
      // Redirect to dashboard after successful password change
      window.location.href = "/dashboard";
    } else {
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setLoader(false);
    toast.error("Please fill all fields correctly");
  };

  return (
    <>
      <Row className="card-row" justify="center">
        <Col xs={24} sm={20} md={16} lg={12} xl={10}>
          <Card bordered={false} className={styles.card} style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
            <Title level={2} className="text-center" style={{ marginBottom: "1rem", marginTop: "0" }}>
              Change Password
            </Title>
            
            <p style={{ textAlign: "center", color: "#666", marginBottom: "1.5rem" }}>
              Please enter your new password. You must change your password to continue.
            </p>

            <Form
              name="changePassword"
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                className="mb-2"
                label="New Password"
                name="newPassword"
                rules={[
                  {
                    required: true,
                    message: "Please input your new password!",
                  },
                  {
                    min: 6,
                    message: "Password must be at least 6 characters!",
                  },
                ]}
              >
                <Input.Password size="large" placeholder="Enter new password" />
              </Form.Item>

              <Form.Item
                className="mb-2"
                label="Confirm Password"
                name="confirmPassword"
                dependencies={['newPassword']}
                rules={[
                  {
                    required: true,
                    message: "Please confirm your password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('newPassword') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Passwords do not match!'));
                    },
                  }),
                ]}
              >
                <Input.Password size="large" placeholder="Confirm new password" />
              </Form.Item>

              <Form.Item className="mt-2">
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  loading={loader}
                  onClick={() => setLoader(true)}
                  block
                >
                  Change Password
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ChangePassword;
